/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | royal_mail_tracked_letter_boxable_24_no_signature | Royal Mail Tracked Letter-Boxable 24 No Signature|
 * | royal_mail_tracked_letter_boxable_48_no_signature | Royal Mail Tracked Letter-Boxable 48 No Signature|
 * | royal_mail_tracked_24_returns | Royal Mail Tracked Returns 24|
 * | royal_mail_tracked_48_returns | Royal Mail Tracked Returns 48|
 * | royal_mail_special_delivery_guaranteed_1pm | Special Delivery Guaranteed by 1pm
 * | royal_mail_special_delivery_guaranteed_9am | Special Delivery Guaranteed by 9am
 * | royal_mail_24 | RoyalMail 24
 * | royal_mail_48 | RoyalMail 48
 * | royal_mail_signed_for_first_class | Signed for First Class
 * | royal_mail_signed_for_second_class | Signed for Second Class
 * | royal_mail_standard_first_class | Standard First Class
 * | royal_mail_standard_second_class | Standard Second Class
 * | royal_mail_tracked_24_no_signature | Royal Mail Tracked 24 No Signature
 * | royal_mail_tracked_48_no_signature | Royal Mail Ttacked 48 No Signature
 * | royal_mail_intl_bus_mail_lrg_ltr_zone_sort_pri | International Business Mail Large Letter Zone Sort Priority
 * | royal_mail_intl_bus_parcels_tracked_zone_sort | International Business Parcels Tracked Zone Sort
 * | royal_mail_intl_bus_parcels_tracked_country_priced | International Business Parcels Tracked Country Priced
 * | royal_mail_intl_bus_parcels_tracked_signed_zone_srt | International Business Parcels & Signed Zone Sort
 * | royal_mail_24_flat_rate | Royal Mail 24 Parcel Flat Rate
 * | royal_mail_48_flat_rate | Royal Mail 48 Parcel Flat Rate
 */
export const ServiceLevelRoyalMailEnum = {
  RoyalMailTrackedLetterBoxable24NoSignature:
    "royal_mail_tracked_letter_boxable_24_no_signature",
  RoyalMailTrackedLetterBoxable48NoSignature:
    "royal_mail_tracked_letter_boxable_48_no_signature",
  RoyalMailTracked24Returns: "royal_mail_tracked_24_returns",
  RoyalMailTracked48Returns: "royal_mail_tracked_48_returns",
  RoyalMailSpecialDeliveryGuaranteed1pm:
    "royal_mail_special_delivery_guaranteed_1pm",
  RoyalMailSpecialDeliveryGuaranteed9am:
    "royal_mail_special_delivery_guaranteed_9am",
  RoyalMail24: "royal_mail_24",
  RoyalMail48: "royal_mail_48",
  RoyalMailSignedForFirstClass: "royal_mail_signed_for_first_class",
  RoyalMailSignedForSecondClass: "royal_mail_signed_for_second_class",
  RoyalMailStandardFirstClass: "royal_mail_standard_first_class",
  RoyalMailStandardSecondClass: "royal_mail_standard_second_class",
  RoyalMailTracked24NoSignature: "royal_mail_tracked_24_no_signature",
  RoyalMailTracked48NoSignature: "royal_mail_tracked_48_no_signature",
  RoyalMailIntlBusMailLrgLtrZoneSortPri:
    "royal_mail_intl_bus_mail_lrg_ltr_zone_sort_pri",
  RoyalMailIntlBusParcelsTrackedZoneSort:
    "royal_mail_intl_bus_parcels_tracked_zone_sort",
  RoyalMailIntlBusParcelsTrackedCountryPriced:
    "royal_mail_intl_bus_parcels_tracked_country_priced",
  RoyalMailIntlBusParcelsTrackedSignedZoneSrt:
    "royal_mail_intl_bus_parcels_tracked_signed_zone_srt",
  RoyalMail24FlatRate: "royal_mail_24_flat_rate",
  RoyalMail48FlatRate: "royal_mail_48_flat_rate",
} as const;
/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | royal_mail_tracked_letter_boxable_24_no_signature | Royal Mail Tracked Letter-Boxable 24 No Signature|
 * | royal_mail_tracked_letter_boxable_48_no_signature | Royal Mail Tracked Letter-Boxable 48 No Signature|
 * | royal_mail_tracked_24_returns | Royal Mail Tracked Returns 24|
 * | royal_mail_tracked_48_returns | Royal Mail Tracked Returns 48|
 * | royal_mail_special_delivery_guaranteed_1pm | Special Delivery Guaranteed by 1pm
 * | royal_mail_special_delivery_guaranteed_9am | Special Delivery Guaranteed by 9am
 * | royal_mail_24 | RoyalMail 24
 * | royal_mail_48 | RoyalMail 48
 * | royal_mail_signed_for_first_class | Signed for First Class
 * | royal_mail_signed_for_second_class | Signed for Second Class
 * | royal_mail_standard_first_class | Standard First Class
 * | royal_mail_standard_second_class | Standard Second Class
 * | royal_mail_tracked_24_no_signature | Royal Mail Tracked 24 No Signature
 * | royal_mail_tracked_48_no_signature | Royal Mail Ttacked 48 No Signature
 * | royal_mail_intl_bus_mail_lrg_ltr_zone_sort_pri | International Business Mail Large Letter Zone Sort Priority
 * | royal_mail_intl_bus_parcels_tracked_zone_sort | International Business Parcels Tracked Zone Sort
 * | royal_mail_intl_bus_parcels_tracked_country_priced | International Business Parcels Tracked Country Priced
 * | royal_mail_intl_bus_parcels_tracked_signed_zone_srt | International Business Parcels & Signed Zone Sort
 * | royal_mail_24_flat_rate | Royal Mail 24 Parcel Flat Rate
 * | royal_mail_48_flat_rate | Royal Mail 48 Parcel Flat Rate
 */
export type ServiceLevelRoyalMailEnum = ClosedEnum<
  typeof ServiceLevelRoyalMailEnum
>;

/** @internal */
export const ServiceLevelRoyalMailEnum$inboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelRoyalMailEnum
> = z.nativeEnum(ServiceLevelRoyalMailEnum);

/** @internal */
export const ServiceLevelRoyalMailEnum$outboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelRoyalMailEnum
> = ServiceLevelRoyalMailEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ServiceLevelRoyalMailEnum$ {
  /** @deprecated use `ServiceLevelRoyalMailEnum$inboundSchema` instead. */
  export const inboundSchema = ServiceLevelRoyalMailEnum$inboundSchema;
  /** @deprecated use `ServiceLevelRoyalMailEnum$outboundSchema` instead. */
  export const outboundSchema = ServiceLevelRoyalMailEnum$outboundSchema;
}
